export const MOCK_CLASSES = [
    { id: "cls-01", name: "Natação Kids", schedule: "Seg/Qua - 18h", clients: 12, status: "Ativa" },
    { id: "cls-02", name: "Funcional 7h", schedule: "Ter/Qui - 07h", clients: 15, status: "Ativa" },
    { id: "cls-03", name: "Pilates Solo", schedule: "Sex - 19h", clients: 6, status: "Pausada" },
]
